module.exports = __webpack_public_path__ + "static/turquia-010-55d938acc2819ce23fdb2d0061aadd12.jpg";